<div class="expiration-date"
     [ngClass]="{ 'expired': expired, 'expiring-soon': expiringSoon }">
  {{ expirationDate | date: 'MM/dd/yyyy' }}
</div>
